import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { List } from 'react-content-loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from 'react-bootstrap';

import useConfigs from '../../hooks/useConfigs';
import SubmitButton from '../Buttons/SubmitButton';

export const News = ({ data, isLoading }) => {
  const { fontSizeMultiplier, activeTheme } = useConfigs();
  const history = useHistory();

  const fixedBackground = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const fixedColor = {
    DEFAULT: activeTheme?.color_base_blanco,
    ROSADO: activeTheme?.color_base_2,
    DARK: activeTheme?.color_base_2,
  };

  const itemcolor = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Container
        theme={activeTheme}
        fontsizemultiplier={fontSizeMultiplier}
        fixedbackground={fixedBackground[activeTheme?.nombre]}
        fixedcolor={fixedColor[activeTheme?.nombre]}
        length={data.length}
      >
        <div className='img-container'>
          <img src={data[0]?.imagen} alt={data[0]?.titulo}/>
          {isLoading ? (
            <div className='fixed'>
              <Spinner
                animation='grow'
                style={{ marginRight: '1rem' }}
                variant='light'
              />
              <Spinner
                animation='grow'
                style={{ marginRight: '1rem' }}
                variant='light'
              />
              <Spinner animation='grow' variant='light' />
            </div>
          ) : (
            <div
              className='fixed'
              onClick={() => {
                history.push({
                  pathname: '/unanoticia',
                  state: { noticia: data[0], noticias: data },
                });
              }}
            >
              <p>{data[0]?.titulo}</p>
              <FontAwesomeIcon
                icon={faArrowRightLong}
                color={fixedColor[activeTheme?.nombre]}
                size='lg'
              />
            </div>
          )}
        </div>

        <div className='lista-container'>
          {isLoading ? (
            <div style={{ padding: '3rem' }}>
              <List style={{ marginBottom: '3rem' }} />
              <List />
            </div>
          ) : (
            data.slice(1, 5).map((item, index) => (
              <Item
                key={item.id}
                theme={activeTheme}
                index={index}
                fontsizemultiplier={fontSizeMultiplier}
                itemcolor={itemcolor[activeTheme?.nombre]}
                onClick={() => {
                  history.push({
                    pathname: '/unanoticia',
                    state: { noticia: item, noticias: data },
                  });
                }}
              >
                <p>{item?.titulo}</p>
                <FontAwesomeIcon
                  icon={faArrowRightLong}
                  color={itemcolor[activeTheme?.nombre]}
                  size='lg'
                />
              </Item>
            ))
          )}
        </div>
      </Container>
      <SubmitButton
        label='Ver todo'
        type='button'
        onClick={() => history.push('/noticias')}
      />
    </div>
  );
};

News.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
};

const Container = styled.div`
  /* outline: 1px solid red; */
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
  border-top: 2px solid ${(props) => props.theme?.color_base_primario};
  border-bottom: 2px solid ${(props) => props.theme?.color_base_primario};
  border-bottom-left-radius: 4rem;
  border-top-left-radius: 4rem;
  overflow: hidden;

  .img-container {
    position: relative;
    width: 58%;
    min-height: 42rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(103%);
    }

    .fixed {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      padding: 1rem 4.5rem 1rem 2.5rem;
      width: 90%;
      border-top-right-radius: 8rem;
      cursor: pointer;
      background-color: ${(props) => props.fixedbackground};

      p {
        font-size: ${(props) => 18 * props.fontsizemultiplier};
        font-weight: 700;
        margin: auto 2rem auto 0;
        color: ${(props) => props.fixedcolor};
      }
    }
  }

  .lista-container {
    display: flex;
    flex-direction: column;
    justify-content: ${(props) =>
      props.length > 4 ? 'space-between' : 'flex-start'};
    width: 42%;
  }

  @media (max-width: 1023px) {
    width: 100%;
    border-radius: 0;

    .img-container {
      display: none;
    }

    .lista-container {
      width: 100%;
    }
  }
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3rem 2.5rem;
  border-bottom: 2px solid
    ${(props) =>
      props.index === 3 ? 'transparent' : props.theme.color_base_primario};
  cursor: pointer;

  p {
    font-size: ${(props) => 18 * props.fontsizemultiplier};
    font-weight: 700;
    margin-right: 1rem;
    color: ${(props) => props.itemcolor};
  }
`;
